var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:{
    'side-link block ps-5 pe-2 py-4 focus:text-gray-900 focus:outline-none focus:shadow-outline': true,
    'hover:bg-primary-600': !_vm.isDropdownItem,
    'rounded-xl hover:bg-primary': _vm.isDropdownItem,
  },attrs:{"to":_vm.toRoute}},[_c('div',{staticClass:"flex items-center"},[_vm._t("icon"),_vm._t("menuItem")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }